import React, { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";
import { Image } from "../../../fe-ui/atoms/Image";

interface Props {
  body?: string;
  children?: ReactNode;
  image?: string;
  isCentered?: boolean;
  title?: string;
  variant?: 'h1' | 'h2' | 'h3';
}

const bodyVariantBy: Record<'h1' | 'h2' | 'h3', 'bodyXl' | 'bodyLg'> = {
  h1: 'bodyXl',
  h2: 'bodyLg',
  h3: 'bodyLg',
};

export const LandingTextBlock = ({
  body,
  children,
  title,
  image,
  isCentered = false,
  variant = 'h1',
}: Props) => {
  return (
    <Stack
      direction={"column"}
      alignItems={isCentered ? "center" : "flex-start"}
      spacing={variant === 'h3' ? 2 : 3}
      sx={[
        isCentered && { textAlign: 'center' },
        { py: 5 },
      ]}
    >
      {title ? <Typography variant={variant} sx={{ maxWidth: '956px' }}>{title}</Typography> : null}
      {body ? <Typography
        component="p"
        variant={bodyVariantBy[variant]}
        sx={{ maxWidth: '956px' }}
      >{body}</Typography> : null}
      {children}
      {image ? <Image
        draggable={false}
        src={image}
      /> : null}
    </Stack>
  );
};
